export const PROJECTS = [
  {
    id: "industrial-warehouse-polishing",
    title: "Industrial Warehouse Floor Polishing",
    category: "Paperless Polishing",
    location: "All India",
    area: "25,000 sq ft",
    service: "paperless-polishing",
    image: "/2.png",
    short: "Complete 5-step densification and polishing of a large industrial warehouse, delivering a dust-free, high-shine surface.",
    description:
      "A major industrial warehouse required complete floor treatment to eliminate dust generation and improve cleanliness standards. Our team applied the 5-step paperless concrete polishing system across 25,000 sq ft, resulting in a sealed, shiny, and highly durable floor that significantly reduced maintenance overhead.",
    gallery: [
      "/4.png",
      "/5.png",
      "/6.png",
    ],
  },
  {
    id: "factory-cream-finish",
    title: "Manufacturing Plant Cream Finish",
    category: "Cream Finishing",
    location: "All India",
    area: "18,000 sq ft",
    service: "cream-finishing",
    image: "/39.png",
    short: "7-step cream finishing system applied to a manufacturing plant floor, achieving a premium stain-resistant sealed surface.",
    description:
      "A manufacturing facility needed a premium floor finish that would withstand heavy foot traffic and equipment movement. We applied our 7-step cream finishing and polishing system, delivering a stain-resistant, dust-proof surface with lasting shine.",
    gallery: [
      "/8.png",
      "/3.png",
      "/2.png",
    ],
  },
  {
    id: "exposed-aggregate-showroom",
    title: "Showroom Exposed Aggregate Floor",
    category: "Exposed Aggregate",
    location: "All India",
    area: "8,000 sq ft",
    service: "exposed-aggregate",
    image: "/33.png",
    short: "Stunning 11-step exposed aggregate (Retro Plate) finish for a commercial showroom, creating a visually dramatic interior.",
    description:
      "A high-end commercial showroom required a visually striking floor. We executed the full 11-step exposed aggregate (Retro Plate) polishing system with a 3000-grade ultra-high gloss finish.",
    gallery: [
      "/1.png",
      "/34.png",
      "/33.png",
    ],
  },
  {
    id: "old-floor-restoration",
    title: "Logistics Hub Floor Restoration",
    category: "Old Floor Densification",
    location: "All India",
    area: "40,000 sq ft",
    service: "old-floor-densification",
    image: "/21.png",
    short: "Complete restoration of a heavily worn logistics hub floor using densification and polishing, avoiding costly replacement.",
    description:
      "A large logistics hub had severely deteriorated flooring with widespread cracking and dusting. We applied our Old Floor Densification System to repair, densify, and polish the surface.",
    gallery: [
      "/19.png",
      "/20.png",
      "/22.png",
    ],
  },
  {
    id: "joint-repair-distribution",
    title: "Distribution Center Joint Repair",
    category: "Joint Repair",
    location: "All India",
    area: "60,000 sq ft",
    service: "joint-repair",
    image: "/9.png",
    short: "HC Cosinus Slide joint repair system installed across a major distribution center to eliminate MHE wheel damage.",
    description:
      "A busy distribution center was experiencing significant joint arris spalling from repetitive MHE wheel movements. We installed the HC Cosinus Slide Repair Joint system throughout the facility.",
    gallery: [
      "/10.png",
      "/11.png",
      "/12.png",
    ],
  },
  {
    id: "safety-signage-plant",
    title: "Automotive Plant Safety Signage",
    category: "Safety Signs",
    location: "All India",
    area: "Full facility",
    service: "safety-signs",
    image: "/15.png",
    short: "Full safety signage solution for an automotive manufacturing plant including epoxy floor markings and retro-reflective boards.",
    description:
      "An automotive manufacturing plant required a comprehensive safety signage overhaul. We designed and installed a complete system including epoxy floor markings, retro-reflective sign boards, and emergency signage.",
    gallery: [
      "/15.png",
      "/14.png",
      "/16.png",
    ],
  },
];
